module.exports = __webpack_public_path__ + "img/05.ea9f6579.png";